/* MBD Marketplace — UI widgets: sliders, carousel, countdown, feed, recent, related, boot */
(function () {
  'use strict';
  var M = window.MBD, $ = M.$, $$ = M.$$;
  var IC_CART = '<svg class="mbd-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/><path d="M13 7v6"/><path d="M10 10h6"/></svg>';

  function initSlider(s) {
    var track = $('.mbd-slider__track', s), prev = $('.mbd-slider__btn--prev', s), next = $('.mbd-slider__btn--next', s);
    if (!track) return;
    function upd() { if (!prev || !next) return; prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.9 }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.9 }); });
    track.addEventListener('scroll', M.debounce(upd, 60), { passive: true });
    upd();
  }

  function initCarousel(c) {
    var track = $('.mbd-carousel__track', c), slides = $$('.mbd-carousel__slide', c), dotsWrap = $('.mbd-carousel__dots', c);
    if (slides.length < 2) { $$('.mbd-slider__btn', c).forEach(function (b) { b.hidden = true; }); return; }
    var idx = 0, timer, delay = Number(c.getAttribute('data-autoplay')) || 0;
    dotsWrap.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Banner ' + (i + 1) + '"></button>'; }).join('');
    var dots = $$('button', dotsWrap);
    function mark() { dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); }
    function go(i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: idx * track.clientWidth }); mark(); }
    function restart() { clearInterval(timer); if (delay) timer = setInterval(function () { if (!document.hidden) go(idx + 1); }, delay); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    var p = $('.mbd-slider__btn--prev', c), n = $('.mbd-slider__btn--next', c);
    if (p) p.addEventListener('click', function () { go(idx - 1); restart(); });
    if (n) n.addEventListener('click', function () { go(idx + 1); restart(); });
    track.addEventListener('scroll', M.debounce(function () { idx = Math.round(track.scrollLeft / track.clientWidth); mark(); }, 80), { passive: true });
    c.addEventListener('mouseenter', function () { clearInterval(timer); });
    c.addEventListener('mouseleave', restart);
    c.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    mark(); restart();
  }

  function initCountdown(el) {
    var endAttr = (el.getAttribute('data-end') || '').trim();
    function nextEnd() {
      var parsed = endAttr ? new Date(endAttr.replace(' ', 'T')) : null;
      if (parsed && !isNaN(parsed) && parsed > new Date()) return parsed;
      var d = new Date(); d.setHours(23, 59, 59, 999); return d;
    }
    var end = nextEnd(), parts = $$('span', el);
    function tick() {
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      if (s === 0) end = nextEnd();
      [Math.floor(s / 3600), Math.floor((s % 3600) / 60), s % 60].forEach(function (v, i) { if (parts[i]) parts[i].textContent = (v < 10 ? '0' : '') + v; });
    }
    tick(); setInterval(tick, 1000);
  }

  function initFeed(f) {
    var grid = $('[data-mbd-feed-grid]', f), more = $('[data-mbd-feed-more]', f), tabs = $$('[data-mbd-feed-tab]', f);
    var next = f.getAttribute('data-next') || '', skel = ($('template[data-skeleton]', f) || {}).innerHTML || '';
    function load(url, replace) {
      if (!url) return;
      if (more) more.classList.add('is-loading');
      if (replace) grid.innerHTML = skel;
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=mbd-feed-items').then(function (r) { return r.text(); }).then(function (html) {
        var box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mbd-feed-items]');
        if (replace) grid.innerHTML = '';
        if (box) { grid.insertAdjacentHTML('beforeend', box.innerHTML); next = box.getAttribute('data-next') || ''; } else next = '';
        if (!grid.children.length) grid.innerHTML = '<p class="mbd-muted" style="grid-column:1/-1;text-align:center;padding:24px">Chưa có sản phẩm trong mục này.</p>';
        if (more) more.parentNode.hidden = !next;
        M.markLoaded(grid);
      }).catch(function () { M.toast('Không tải được sản phẩm, vui lòng thử lại.', 'error'); })
        .finally(function () { if (more) more.classList.remove('is-loading'); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-active')) return;
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        load(t.getAttribute('data-url'), true);
        var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0;
        var top = f.getBoundingClientRect().top + window.scrollY - hh - 8;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
    if (more) { more.parentNode.hidden = !next; more.addEventListener('click', function () { load(next, false); }); }
  }

  var RKEY = 'mbd_recent';
  M.trackRecent = function (handle) { if (!handle) return; var r = M.store.get(RKEY, []).filter(function (h) { return h !== handle; }); r.unshift(handle); M.store.set(RKEY, r.slice(0, 16)); };
  M.cardHTML = function (p) {
    var vs = p.variants || [], v = vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
    var price = v.price != null ? v.price : p.price, cmp = v.compare_at_price || 0, sale = cmp > price;
    var pct = sale ? Math.max(1, Math.floor((cmp - price) * 100 / cmp)) : 0;
    var img = p.featured_image || '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
    var single = vs.length === 1;
    var add = p.available ? (single ? '<button type="button" class="mbd-card__add" data-mbd-add="' + v.id + '" aria-label="Thêm vào giỏ">' + IC_CART + '</button>' : '<a href="' + p.url + '" class="mbd-card__add" aria-label="Chọn phân loại">' + IC_CART + '</a>') : '';
    return '<div class="mbd-card' + (p.available ? '' : ' is-soldout') + '"><a href="' + p.url + '" class="mbd-card__media mbd-media" aria-label="' + M.esc(p.title) + '">' +
      (src ? '<img src="' + src + '" alt="' + M.esc(p.title) + '" loading="lazy" width="400" height="400" onload="this.parentNode.classList.add(\'is-loaded\')">' : '') +
      (sale ? '<span class="mbd-card__pct">-' + pct + '%</span>' : '') + (p.available ? '' : '<span class="mbd-card__soldout">HẾT HÀNG</span>') +
      '</a><div class="mbd-card__body"><a href="' + p.url + '" class="mbd-card__title">' + M.esc(p.title) + '</a><div class="mbd-card__bottom"><div class="mbd-card__prices"><span class="mbd-price">' + M.formatMoney(price) + '</span>' +
      (sale ? '<s class="mbd-compare">' + M.formatMoney(cmp) + '</s>' : '') + '</div>' + add + '</div></div></div>';
  };
  function initRecent(box) {
    var current = box.getAttribute('data-current'), limit = Number(box.getAttribute('data-limit')) || 6;
    var section = box.closest('[data-mbd-recent-section]');
    var list = M.store.get(RKEY, []).filter(function (h) { return h !== current; }).slice(0, limit);
    if (!list.length) { if (section) section.hidden = true; return; }
    Promise.all(list.map(function (h) { return fetch(M.root() + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean);
        if (!ps.length) { if (section) section.hidden = true; return; }
        box.innerHTML = ps.map(M.cardHTML).join('');
        if (section) section.hidden = false;
      });
  }
  function initRelated(box) {
    var section = box.closest('[data-mbd-related-section]');
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var items = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mbd-related-items]');
      if (items && items.children.length) { box.innerHTML = items.innerHTML; M.markLoaded(box); }
      else if (section) section.hidden = true;
    }).catch(function () { if (section) section.hidden = true; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mbd-copy]');
    if (!b) return;
    var code = b.getAttribute('data-mbd-copy'), done = function () { M.toast('Đã sao chép mã ' + code); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  M.init = function (scope) {
    M.markLoaded(scope);
    $$('[data-mbd-search]', scope).forEach(M.initSearch);
    $$('[data-mbd-slider]', scope).forEach(initSlider);
    $$('[data-mbd-carousel]', scope).forEach(initCarousel);
    $$('[data-mbd-countdown]', scope).forEach(initCountdown);
    $$('[data-mbd-feed]', scope).forEach(initFeed);
    $$('[data-mbd-recent]', scope).forEach(initRecent);
    $$('[data-mbd-related]', scope).forEach(initRelated);
    if (M.initPages) M.initPages(scope);
  };
  function boot() { M.initHeader(); M.initSearchOverlay(); M.init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { M.init(e.target); });
})();